/**
 * Created by Yaroslav S. on 16/04/24.
 * Copyright © 2024 SEVEN. All rights reserved.
 */

import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Options } from '@angular-slider/ngx-slider';

type gradesType = {
  grade: string;
  gcseGrade: string;
  from: number;
  to: number;
  useGcse: boolean;
};

@Component({
  selector: 'curr-share-confirmation-popup',
  templateUrl: './share-confirmation-popup.component.html',
  styleUrls: ['./share-confirmation-popup.component.scss']
})
export class ShareConfirmationPopupComponent implements OnInit, AfterViewInit {
  dialogTitle!: string;
  grades: gradesType[];

  options: Options = {
    floor: 0,
    ceil: 100,
    step: 1,
    draggableRange: false,
    showTicks: false
  };

  isSliderLoader = false;

  private MIN_RANGE = 1;

  constructor(
    public dialogRef: MatDialogRef<ShareConfirmationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.dialogTitle = this.data.title;
    if (this.data.grades) {
      this.isSliderLoader = true;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.data.grades.length > 0) {
        this.grades = this.data.grades;

        this.grades = this.data.grades.sort((a, b) => {
          if (!a.gcseGrade) {
            a.gcseGrade = 0;
          }
          return Number(b.gcseGrade) - Number(a.gcseGrade);
        });

        this.grades = this.grades.map((item) => {
          if (item.to > 100) item.to = item.to - 1;
          return item;
        });
      }

      this.isSliderLoader = false;
    }, 1000);
  }

  confirm() {
    this.dialogRef.close({confirm: true, grades: this.grades});
  }

  onChangeGrade(index: number) {
    const current = this.grades[index];

    if (current.to - current.from < this.MIN_RANGE) {
      current.to = current.from + this.MIN_RANGE;
    }

    for (let i = index; i < this.grades.length - 1; i++) {
      const curr = this.grades[i];
      const next = this.grades[i + 1];

      next.to = curr.from - this.MIN_RANGE;

      if (next.to - next.from < this.MIN_RANGE) {
        next.from = next.to - this.MIN_RANGE;
      }
    }

    for (let i = index; i > 0; i--) {
      const curr = this.grades[i];
      const prev = this.grades[i - 1];

      prev.from = curr.to + this.MIN_RANGE;

      if (prev.to - prev.from < this.MIN_RANGE) {
        prev.to = prev.from + this.MIN_RANGE;
      }
    }

    // ToDo:: Should be deleted because it is old hardcoded way (only for testing with 9 grades)
    // for (let i = 0; i < this.grades.length - 1; i++) {
    //   if (this.grades[0].to > 100) this.grades[0].to = 100;
    //   if (this.grades[1].to > 98) this.grades[1].to = 98;
    //   if (this.grades[2].to > 96) this.grades[2].to = 96;
    //   if (this.grades[3].to > 94) this.grades[3].to = 94;
    //   if (this.grades[4].to > 92) this.grades[4].to = 92;
    //   if (this.grades[5].to > 90) this.grades[5].to = 90;
    //   if (this.grades[6].to > 88) this.grades[6].to = 88;
    //   if (this.grades[7].to > 86) this.grades[7].to = 86;
    //   if (this.grades[8].to > 84) this.grades[8].to = 84;
    //
    //   if (this.grades[0].from > 99) this.grades[0].from = 99;
    //   if (this.grades[1].from > 97) this.grades[1].from = 97;
    //   if (this.grades[2].from > 95) this.grades[2].from = 95;
    //   if (this.grades[3].from > 93) this.grades[3].from = 93;
    //   if (this.grades[4].from > 91) this.grades[4].from = 91;
    //   if (this.grades[5].from > 89) this.grades[5].from = 89;
    //   if (this.grades[6].from > 87) this.grades[6].from = 87;
    //   if (this.grades[7].from > 85) this.grades[7].from = 85;
    //   if (this.grades[8].from > 83) this.grades[8].from = 83;
    //
    //   if ( this.grades[0].to < 9 ) this.grades[0].to = 17;
    //   if ( this.grades[1].to < 8 ) this.grades[1].to = 15;
    //   if ( this.grades[2].to < 7 ) this.grades[2].to = 13;
    //   if ( this.grades[3].to < 6 ) this.grades[3].to = 11;
    //   if ( this.grades[4].to < 5 ) this.grades[4].to = 9;
    //   if ( this.grades[5].to < 4 ) this.grades[5].to = 7;
    //   if ( this.grades[6].to < 3 ) this.grades[6].to = 5;
    //   if ( this.grades[7].to < 2 ) this.grades[7].to = 3;
    //   if ( this.grades[8].to < 1 ) this.grades[8].to = 1;
    //
    //   if ( this.grades[0].from < 9 ) this.grades[0].from = 16;
    //   if ( this.grades[1].from < 8 ) this.grades[1].from = 14;
    //   if ( this.grades[2].from < 7 ) this.grades[2].from = 12;
    //   if ( this.grades[3].from < 6 ) this.grades[3].from = 10;
    //   if ( this.grades[4].from < 5 ) this.grades[4].from = 8;
    //   if ( this.grades[5].from < 4 ) this.grades[5].from = 6;
    //   if ( this.grades[6].from < 3 ) this.grades[6].from = 4;
    //   if ( this.grades[7].from < 2 ) this.grades[7].from = 2;
    //   if ( this.grades[8].from < 1 ) this.grades[8].from = 0;
    // }

    const n = this.grades.length;

    for (let i = 0; i < n; i++) {
      // max values
      const toMax = 100 - i * 2;
      const fromMax = 99 - i * 2;

      if (this.grades[i].to > toMax) this.grades[i].to = toMax;
      if (this.grades[i].from > fromMax) this.grades[i].from = fromMax;

      // min values
      const toMin = (n - 1 - i) * 2 + 1;
      const fromMin = (n - 1 - i) * 2;

      if (this.grades[i].to < toMin) this.grades[i].to = toMin;
      if (this.grades[i].from < fromMin) this.grades[i].from = fromMin;
    }

    this.grades[0].to = 100;
    this.grades[this.grades.length - 1].from = 0;
  }
}
